import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`btn ns-filters ns-expand-filters ${className}`}
        >
            <span>Filter / Sort</span>
            <svg aria-label="Filter icon" class="icon icon--filter" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.2 3V12.8182M3 17.7273H9.4M6.2 14.4545V21M12.6 21V14.0455M12.6 14.0455C13.1304 14.0455 13.6391 13.83 14.0142 13.4464C14.3893 13.0628 14.6 12.5425 14.6 12C14.6 11.4575 14.3893 10.9372 14.0142 10.5536C13.6391 10.17 13.1304 9.95454 12.6 9.95454M12.6 14.0455C12.3374 14.0455 12.0773 13.9925 11.8346 13.8898C11.592 13.787 11.3715 13.6363 11.1858 13.4464C11.0001 13.2564 10.8528 13.0309 10.7522 12.7828C10.6517 12.5346 10.6 12.2686 10.6 12C10.6 11.7314 10.6517 11.4654 10.7522 11.2172C10.8528 10.9691 11.0001 10.7436 11.1858 10.5536C11.3715 10.3637 11.592 10.213 11.8346 10.1102C12.0773 10.0075 12.3374 9.95454 12.6 9.95454M12.6 9.95454V3M19 21V7.90909M19 7.90909C20.1046 7.90909 21 6.99331 21 5.86364C21 4.73396 20.1046 3.81818 19 3.81818C17.8954 3.81818 17 4.73396 17 5.86364C17 6.99331 17.8954 7.90909 19 7.90909Z" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
            </div>
        </div>
    )
}
